import { render, staticRenderFns } from "./article-review-item.vue?vue&type=template&id=2712f07c&scoped=true"
import script from "./article-review-item.vue?vue&type=script&lang=js"
export * from "./article-review-item.vue?vue&type=script&lang=js"
import style0 from "./article-review-item.vue?vue&type=style&index=0&id=2712f07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2712f07c",
  null
  
)

export default component.exports